import React, { Component } from "react";
import { Card, Stack, Icon, Type, Link } from "react-spark";

class ContactInfo extends Component {
  render() {
    const { isDisplayed = true, config } = this.props;
    if (!isDisplayed) {
      return null;
    }
    const { phone, officeHours, email } = config;
    return (
      <Card>
        <Card.Content className="sprk-u-TextAlign--center">
          <Stack>
            <Stack.Item>
              <Icon name="call-team-member" size={Icon.size.XXL} />
            </Stack.Item>
          </Stack>
        </Card.Content>

        <Card.Content className="sprk-u-TextAlign--center">
          <Stack>
            <Stack.Item>
              <Type.DisplayFive>Have a Question?</Type.DisplayFive>
            </Stack.Item>
            <Stack.Item>
              <Type.BodyThree className="text-bold">Contact Us</Type.BodyThree>
              <Type.BodyThree>
                <Link href={`tel://${phone.dash}`}>
                  {phone.dash}
                </Link>
              </Type.BodyThree>
              <Type.BodyThree>{officeHours}</Type.BodyThree>
              <Type.BodyThree>
                <Link
                  href={`mailto:${email.support}?Subject=Talk%20to%20Us`}
                  target="_top"
                >
                  {email.support}
                </Link>
              </Type.BodyThree>
            </Stack.Item>
          </Stack>
        </Card.Content>
      </Card>
    );
  }
}

export default ContactInfo;
